import { Col, Row } from "reactstrap";
import Organization from "./Organization";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import Analysis from "./Analysis";
import { useLabratorFindAllQuery } from "store";
import labSvg from "../../assets/images/svg/lab.svg"
import Create from "./Create";
import Spinners from "Components/Common/Spinner";

const ComponentLabrator = (props: any) => {
  const [sectionBoolean, setSectionBoolean] = useState(true);
  const [labratorOne, setLabratorOne] = useState<any>(null);
  const [labMainList, setLabMainList] = useState<any>();
  const [tableId, setTableId] = useState<any>();
  const [newLabCreate, setNewLabCreate] = useState<boolean>(false);

  const {
    data: labData,
    error: labDataError,
    isFetching: isLabDataFetching,
  } = useLabratorFindAllQuery(`?table_name=${props?.table}&connection_id=${props?.table_id}`);

  useEffect(() => {

    setLabMainList(labData?.data);
  }, [props?.table_id, props?.table, labData, labratorOne,])
  return (
    <>
      <Row>

        <Row>
          <Col lg={12}>
            <div className="d-flex align-items-center mb-3">
              <img src={labSvg} alt="" height="50" />
              <div className="flex-grow-1 ms-3">
                <h5 className="fw-semibold">Мэдээлэл</h5>
                <ul className="list-unstyled hstack gap-2 mb-0">
                  <li>
                    <i className="mdi mdi-table-row-height"></i>{" "}
                    <span className="text-muted fw-semibold">
                      Нийт: {labMainList?.length}
                    </span>
                  </li>
                </ul>
              </div>
              <button
                type="button"
                disabled={newLabCreate}
                onClick={() => {
                  setNewLabCreate(true)
                }}
                className="btn btn-success  btn-label"
              >
                <i className="mdi mdi-file-plus-outline label-icon"></i> Шинээр нэмэх
              </button>
            </div>
          </Col>
        </Row>

        <Col lg={3}>
          <ul className="verti-timeline list-unstyled">
            {labMainList?.map((item, index) => (
              <li className="event-list active">
                <div className="event-timeline-dot">
                  <i className="bx bxs-right-arrow-circle font-size-18 bx-fade-right" />
                </div>
                <div className="flex-shrink-0 d-flex">
                  <div key={index} className="d-flex mb-3">
                    <div className="me-3">
                      <h5 className="font-size-14">
                        {item?.created_at.split("T")[0]}
                        <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                      </h5>
                    </div>
                    <div className="flex-grow-1">
                      <div>
                        <Link
                          to="#"
                          className="cursor fw-semibold"
                          onClick={() => {
                            setSectionBoolean(true);
                            setLabratorOne(item);
                            setNewLabCreate(false)
                          }}
                        >
                          {item?.lab_description}
                        </Link>
                        {" - "}
                        <Link
                          to="#"
                          className="cursor fw-semibold text-success"
                          onClick={() => {
                            setSectionBoolean(false);
                            setTableId(item?.id);
                          }}
                        >
                          Хариу
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </Col>
        {
          newLabCreate ? (
            <Col lg={9}>
              <Create id={props?.table_id} table_name={props?.table} />
            </Col>
          ) : (
            <Col lg={9}>
              {sectionBoolean ? (
                <Organization data={labratorOne} id={props?.table_id} table_name={props?.table} />
              ) : (
                <Analysis table_id={tableId} />
              )}
            </Col>
          )
        }


      </Row>

    </>
  );
};

export default ComponentLabrator;
